module.exports = __webpack_public_path__ + "static/media/login_video_3000.cbbd5442.webm";